import React from 'react';
export function CampaignEmailIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zM5 6h14a1 1 0 011 1v1.279l-7.684 2.562a1.012 1.012 0 01-.632 0L4 8.279V7a1 1 0 011-1zm14 12H5a1 1 0 01-1-1v-6.613l7.051 2.351a3.02 3.02 0 001.9 0L20 10.387V17a1 1 0 01-1 1z"
  }));
}